import { mergeProps, splitProps, useContext } from "solid-js";
import CloseButton from "./CloseButton";
import ModalContext from "./ModalContext";
const defaultProps = {
    closeLabel: "Close",
    closeButton: false,
};
const AbstractModalHeader = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children",
    ]);
    const context = useContext(ModalContext);
    const handleClick = () => {
        context?.onHide();
        local.onHide?.();
    };
    return (<div {...props}>
      {local.children}

      {local.closeButton && (<CloseButton aria-label={local.closeLabel} variant={local.closeVariant} onClick={handleClick}/>)}
    </div>);
};
export default AbstractModalHeader;
